import { render, staticRenderFns } from "./IdentityType.vue?vue&type=template&id=1538dade&"
import script from "./IdentityType.vue?vue&type=script&lang=js&"
export * from "./IdentityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports